module.exports = () => {
  const nav = document.getElementById('header-navigation')
  const menuButton = document.getElementById('toggle-menu')
  const translationButton = document.getElementById('translations-desktop-btn')
  const searchButton = document.getElementById('toggle-search')

  const addFocus = () => {
    const navigationLinksList = nav.getElementsByClassName(
      'hse-header-dropdown__navigation-link'
    )
    const lastLink = navigationLinksList[navigationLinksList.length - 1]
    // eslint-disable-next-line prefer-destructuring
    const firstLink = navigationLinksList[0]
    const [logoLink] = document.getElementsByClassName(
      'hse-header-dropdown__link'
    )
    if (nav.classList.contains('js-show')) {
      menuButton.addEventListener('keydown', (event) => {
        if (event.key === 'Tab' && nav.classList.contains('js-show')) {
          event.preventDefault()
          menuButton.blur()
          navigationLinksList[0].focus()
        }
        if (
          event.key === 'Tab' &&
          event.shiftKey &&
          nav.classList.contains('js-show')
        ) {
          menuButton.blur()
          menuButton.click()
          logoLink.focus()
        }
      })

      lastLink.addEventListener('keydown', (event) => {
        if (event.key === 'Tab' && !event.shiftKey) {
          event.preventDefault()
          if (translationButton) {
            translationButton.focus()
          } else if (searchButton) {
            searchButton.focus()
          }
          if (nav.classList.contains('js-show')) {
            menuButton.click()
          }
        }
      })

      firstLink.addEventListener('keydown', (event) => {
        if (event.key === 'Tab' && event.shiftKey) {
          event.preventDefault()
          firstLink.blur()
          menuButton.focus()
        }
      })
    }
  }

  const toggleEnter = () => {
    menuButton.addEventListener('keyup', (event) => {
      if (event.currentTarget.id === 'toggle-menu') {
        if (event.key === 'Enter') {
          addFocus()
        }
      }
    })
  }

  if (menuButton) toggleEnter()
}
